import Vue from 'vue';
import { VueReCaptcha } from 'vue-recaptcha-v3';

let isRecaptchaLoaded = false;

/**
 * Dynamically load reCAPTCHA plugin only when needed
 * This prevents reCAPTCHA from loading on every page of the application
 */
export const loadRecaptcha = () => {
  if (isRecaptchaLoaded) {
    return Promise.resolve();
  }

  return new Promise((resolve, reject) => {
    try {
      // Check if reCAPTCHA key is available
      if (!process.env.VUE_APP_RECAPTCHA_KEY) {
        console.warn('VUE_APP_RECAPTCHA_KEY not found, skipping reCAPTCHA initialization');
        resolve();
        return;
      }

      Vue.use(VueReCaptcha, {
        siteKey: process.env.VUE_APP_RECAPTCHA_KEY,
        loaderOptions: {
          autoHideBadge: true,
        },
      });

      isRecaptchaLoaded = true;
      resolve();
    } catch (error) {
      console.error('Failed to load reCAPTCHA:', error);
      reject(error);
    }
  });
};

/**
 * Check if reCAPTCHA is already loaded
 */
export const isRecaptchaReady = () => isRecaptchaLoaded;
